var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApteanLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.74 318.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.56,255.68l-139.79-229a12.33,12.33,0,0,0-14.62-5.23l143.49,235a12.88,12.88,0,0,1,.59,12.32l-28.32,58.47a13.07,13.07,0,0,1-2,3,12.31,12.31,0,0,0,14-6.62l27.21-56.16A12.37,12.37,0,0,0,339.56,255.68Z",
    transform: "translate(-18.63 -20.8)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.95 275.73 217.34 269.22 233.44 295.77 196.95 275.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.71 84.07 151.34 164.26 138.49 193 37.3 223.88 101.71 84.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.68,323.35,51,255.41,188.16,213.5,231,282.36,32.88,338.76A11.17,11.17,0,0,1,19.68,323.35Z",
    transform: "translate(-18.63 -20.8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.83,268.84l-27.31,56.37a12.4,12.4,0,0,1-21.68,1.18L124.53,95.77l30.52-67.28a12.41,12.41,0,0,1,21.89-1.34L317.25,257A12.42,12.42,0,0,1,317.83,268.84Z",
    transform: "translate(-18.63 -20.8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.83,268.84l-27.31,56.37a12.4,12.4,0,0,1-21.68,1.18L124.53,95.77l30.52-67.28a12.41,12.41,0,0,1,21.89-1.34L317.25,257A12.42,12.42,0,0,1,317.83,268.84Z",
    transform: "translate(-18.63 -20.8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApteanLogoWhite);
export default __webpack_public_path__ + "static/media/ApteanLogoWhite.4735b7ec13928da9ee789512af368564.svg";
export { ForwardRef as ReactComponent };